module.exports = __webpack_public_path__ + "img/call.894875d7.svg";